import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import NavButton from "./nav-button";

gsap.registerPlugin(ScrollTrigger);

class FooterFade {

    constructor () {
        // Check for Zoom Images
        const footerBoxes = document.querySelector('.js-footer-items')
        if(footerBoxes) {
            this.init()
        }
    }

    init() {
        window.addEventListener('load', () => {

            const footerBoxes = document.querySelectorAll('.js-footer-items')

            footerBoxes.forEach(function(item) {

                let tl = gsap.timeline({
                    scrollTrigger:{
                        trigger: item,
                        start:"top 100%",
                        markers: false,
                        toggleActions: 'play none none none'
                    }
                }).from(item.querySelectorAll('.js-footer-inner'), {
                    opacity: 0,
                    y: "20px",
                    duration: .8,
                    ease: 'power3.out',
                    stagger: .16
                })
            })
        })
    }
}

export default FooterFade;
